export const teams = [
	{
		id: 1,
		id: "panas",
		name: "Las Panas",
	},
	{
		id: 2,
		id: "aguilas",
		name: "Águilas",
	},
	{
		id: 3,
		id: "espartanas",
		name: "Espartanas",
	},
	{
		id: 4,
		id: "murallas",
		name: "Murallas",
	},
	{
		id: 5,
		id: "panteras",
		name: "Panteras",
	},
	{
		id: 6,
		id: "vikingas",
		name: "Vikingas",
	},
	{
		id: 7,
		id: 1,
		name: "1ro",
	},
	{
		id: 8,
		id: 2,
		name: "2do",
	},
	{
		id: 9,
		id: 3,
		name: "3ro",
	},
	{
		id: 10,
		id: 4,
		name: "4to",
	},
];

export const locations = [
	{
		id: 1,
		name: "Aravaca",
		address: "Aravaca",
	},
	{
		id: 2,
		name: "Lago",
		address: "Paseo Puerta del Ángel, 13",
	},
	{
		id: 3,
		name: "Jarama",
		address: "Av. de San Sebastián, 15",
	},
];

export const locationTypes = {
	1: {
		icon: "map-pin",
		color: "secondary",
		label: "Aravaca: Calle del Escultor Peresejo, 11",
		link: "https://goo.gl/maps/97N9kBBhBPtKx76P6",
	},
	2: {
		icon: "map-pin",
		color: "secondary",
		label: "Lago: Paseo Puerta del Ángel, 13",
		link: "https://goo.gl/maps/fZ8RZXhoPrMdoXSHA",
	},
	3: {
		icon: "map-pin",
		color: "secondary",
		label: "Jarama: Av. de San Sebastián, 15",
		link: "https://goo.gl/maps/gxmee9ZKVYunv4rB9",
	},
};

export const scoreTypes = {
	1: {
		abbrev: "PJ",
		color: "secondary",
		label: "Partidos jugados",
	},
	2: {
		abbrev: "PG",
		color: "secondary",
		label: "Partidos Ganados",
	},
	3: {
		abbrev: "PP",
		color: "secondary",
		label: "Partidos Perdidos",
	},
	4: {
		abbrev: "PE",
		color: "secondary",
		label: "Partidos Empatados",
	},
	5: {
		abbrev: "CF",
		color: "secondary",
		label: "Carreras a favor",
	},
	6: {
		abbrev: "CC",
		color: "secondary",
		label: "Carreras en contra",
	},
	7: {
		abbrev: "DIF",
		color: "secondary",
		label: "Diferencia",
	},
	8: {
		abbrev: "PTS",
		color: "secondary",
		label: "Puntos",
	},
};

export const events = [
	[
		{
			id: 1,
			homeclubId: "aguilas",
			visitorId: "panteras",
			locationId: 2,
			date: "2021-04-11T09:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
		{
			id: 2,
			homeclubId: "espartanas",
			visitorId: "vikingas",
			locationId: 2,
			date: "2021-04-11T11:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
		{
			id: 3,
			homeclubId: "murallas",
			visitorId: "panas",
			locationId: 2,
			date: "2021-04-11T13:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
	],
	[
		{
			id: 4,
			homeclubId: "panas",
			visitorId: "espartanas",
			locationId: 3,
			date: "2021-04-18T09:30:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 4,
		},
		{
			id: 5,
			homeclubId: "panteras",
			visitorId: "murallas",
			locationId: 3,
			date: "2021-04-18T11:15:00.000Z",
			scoreHomeclub: 9,
			scoreVisitor: 1,
		},
		{
			id: 6,
			homeclubId: "vikingas",
			visitorId: "aguilas",
			locationId: 3,
			date: "2021-04-18T13:00:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 4,
		},
	],
	[
		{
			id: 7,
			homeclubId: "aguilas",
			visitorId: "panas",
			locationId: 1,
			date: "2021-04-25T11:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
		{
			id: 8,
			homeclubId: "espartanas",
			visitorId: "murallas",
			locationId: 1,
			date: "2021-04-25T13:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
		{
			id: 9,
			homeclubId: "vikingas",
			visitorId: "panteras",
			locationId: 1,
			date: "2021-04-25T15:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
	],
	[
		{
			id: 10,
			homeclubId: "panas",
			visitorId: "vikingas",
			locationId: 3,
			date: "2021-05-09T10:00:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 5,
		},
		{
			id: 11,
			homeclubId: "espartanas",
			visitorId: "panteras",
			locationId: 3,
			date: "2021-05-09T11:45:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 4,
		},
		{
			id: 12,
			homeclubId: "murallas",
			visitorId: "aguilas",
			locationId: 3,
			date: "2021-05-09T13:30:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 5,
		},
	],
	[
		{
			id: 13,
			homeclubId: "aguilas",
			visitorId: "espartanas",
			locationId: 3,
			date: "2021-05-16T10:00:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 1,
		},
		{
			id: 14,
			homeclubId: "panteras",
			visitorId: "panas",
			locationId: 3,
			date: "2021-05-16T11:45:00.000Z",
			scoreHomeclub: 8,
			scoreVisitor: 6,
		},
		{
			id: 15,
			homeclubId: "vikingas",
			visitorId: "murallas",
			locationId: 3,
			date: "2021-05-16T13:30:00.000Z",
			scoreHomeclub: 7,
			scoreVisitor: 0,
		},
	],
	[
		{
			id: 16,
			homeclubId: "panteras",
			visitorId: "aguilas",
			locationId: 3,
			date: "2021-05-23T10:00:00.000Z",
			scoreHomeclub: 6,
			scoreVisitor: 6,
		},
		{
			id: 17,
			homeclubId: "vikingas",
			visitorId: "espartanas",
			locationId: 3,
			date: "2021-05-23T11:45:00.000Z",
			scoreHomeclub: 13,
			scoreVisitor: 4,
		},
		{
			id: 18,
			homeclubId: "panas",
			visitorId: "murallas",
			locationId: 3,
			date: "2021-05-23T13:30:00.000Z",
			scoreHomeclub: 10,
			scoreVisitor: 4,
		},
	],
	[
		{
			id: 19,
			homeclubId: "espartanas",
			visitorId: "panas",
			locationId: 3,
			date: "2021-05-30T10:00:00.000Z",
			scoreHomeclub: 3,
			scoreVisitor: 4,
		},
		{
			id: 20,
			homeclubId: "murallas",
			visitorId: "panteras",
			locationId: 3,
			date: "2021-05-30T11:45:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 12,
		},
		{
			id: 21,
			homeclubId: "aguilas",
			visitorId: "vikingas",
			locationId: 3,
			date: "2021-05-30T13:30:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 10,
		},
	],
	[
		{
			id: 22,
			homeclubId: "panas",
			visitorId: "aguilas",
			locationId: 3,
			date: "2021-06-06T10:00:00.000Z",
			scoreHomeclub: null,
			scoreVisitor: null,
			cancelled: true,
		},
		{
			id: 23,
			homeclubId: "murallas",
			visitorId: "espartanas",
			locationId: 3,
			date: "2021-06-06T11:45:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 1,
		},
		{
			id: 24,
			homeclubId: "panteras",
			visitorId: "vikingas",
			locationId: 3,
			date: "2021-06-06T13:30:00.000Z",
			scoreHomeclub: 10,
			scoreVisitor: 1,
		},
	],
	[
		{
			id: 25,
			homeclubId: "vikingas",
			visitorId: "panas",
			locationId: 3,
			date: "2021-06-13T09:00:00.000Z",
			scoreHomeclub: 7,
			scoreVisitor: 0,
		},
		{
			id: 26,
			homeclubId: "panteras",
			visitorId: "espartanas",
			locationId: 3,
			date: "2021-06-13T10:45:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 4,
		},
		{
			id: 27,
			homeclubId: "aguilas",
			visitorId: "murallas",
			locationId: 3,
			date: "2021-06-13T12:30:00.000Z",
			scoreHomeclub: 11,
			scoreVisitor: 1,
		},
	],
	[
		{
			id: 28,
			homeclubId: "espartanas",
			visitorId: "aguilas",
			locationId: 3,
			date: "2021-06-20T09:00:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 0,
		},
		{
			id: 29,
			homeclubId: "panas",
			visitorId: "panteras",
			locationId: 3,
			date: "2021-06-20T10:45:00.000Z",
			scoreHomeclub: 1,
			scoreVisitor: 10,
		},
		{
			id: 30,
			homeclubId: "murallas",
			visitorId: "vikingas",
			locationId: 3,
			date: "2021-06-20T12:30:00.000Z",
			scoreHomeclub: 5,
			scoreVisitor: 5,
		},
	],
	[
		{
			id: 35,
			homeclubId: "aguilas",
			visitorId: "panteras",
			locationId: 3,
			date: "2021-06-27T09:00:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 5,
		},
		{
			id: 36,
			homeclubId: "espartanas",
			visitorId: "vikingas",
			locationId: 3,
			date: "2021-06-27T10:45:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 2,
		},
		{
			id: 37,
			homeclubId: "murallas",
			visitorId: "panas",
			locationId: 3,
			date: "2021-06-27T12:30:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 4,
		},
		{
			id: 38,
			homeclubId: "panas",
			visitorId: "aguilas",
			locationId: 3,
			date: "2021-06-27T14:15:00.000Z",
			scoreHomeclub: 2,
			scoreVisitor: 11,
		},
	],
	[
		{
			id: 39,
			homeclubId: "aguilas",
			visitorId: "panas",
			locationId: 3,
			date: "2021-07-04T09:00:00.000Z",
			scoreHomeclub: 8,
			scoreVisitor: 1,
		},
		{
			id: 40,
			homeclubId: "espartanas",
			visitorId: "murallas",
			locationId: 3,
			date: "2021-07-04T10:45:00.000Z",
			scoreHomeclub: 11,
			scoreVisitor: 1,
		},
		{
			id: 41,
			homeclubId: "vikingas",
			visitorId: "panteras",
			locationId: 3,
			date: "2021-07-04T12:30:00.000Z",
			scoreHomeclub: 6,
			scoreVisitor: 6,
		},
	],
	[
		{
			id: 31,
			homeclubId: "panteras",
			visitorId: "espartanas",
			locationId: 3,
			date: "2021-07-11T09:30:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 8,
			finals: true,
		},
		{
			id: 32,
			homeclubId: "vikingas",
			visitorId: "aguilas",
			locationId: 3,
			date: "2021-07-11T11:30:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 3,
			finals: true,
		},
	],
	[
		{
			id: 33,
			homeclubId: "aguilas",
			visitorId: "panteras",
			locationId: 3,
			date: "2021-07-18T09:30:00.000Z",
			scoreHomeclub: 0,
			scoreVisitor: 6,
			finals: true,
			// TBD: true,
		},
		{
			id: 34,
			homeclubId: "vikingas",
			visitorId: "espartanas",
			locationId: 3,
			date: "2021-07-18T11:30:00.000Z",
			scoreHomeclub: 4,
			scoreVisitor: 7,
			finals: true,
			// TBD: true,
		},
	],
];
